import React, { useState } from 'react';
import EventList from './event-list';
import DistanceDisplay from './distance-display';
import EmployerList from './employer-list';
import './signal-tabs.css';

const SignalTabs = ({ signals, metadata }) => {
  const [activeTab, setActiveTab] = useState('all');

  const renderTabContent = () => {
    const content = [];
    if (activeTab === 'all' || activeTab === 'events') {
        if (metadata.coattendee) {
            content.push(<EventList key="events" events={metadata.coattendee.sharedEvents} />);
        }
    }
    if (activeTab === 'all' || activeTab === 'proximity') {
        if (metadata.geographic) {
            content.push(<DistanceDisplay key="distance" distance={metadata.geographic.distanceMiles} location={metadata.geographic.location} />);
        }
    }
    if (activeTab === 'all' || activeTab === 'employers') {
        if (metadata.employer) {
            content.push(<EmployerList key="employers" employers={metadata.employer.sharedEmployers} />);
        }
    }
    return content;
  };

  return (
    <div className="signal-tabs">
      <div className="tab-bar">
        <button type="button" onClick={() => setActiveTab('all')} className={activeTab === 'all' ? 'active' : ''}>All</button>
        {signals.includes('coattendee') && <button type="button" onClick={() => setActiveTab('events')} className={activeTab === 'events' ? 'active' : ''}>Events</button>}
        {signals.includes('geographic') && <button type="button" onClick={() => setActiveTab('proximity')} className={activeTab === 'proximity' ? 'active' : ''}>Proximity</button>}
        {signals.includes('employer') && <button type="button" onClick={() => setActiveTab('employers')} className={activeTab === 'employers' ? 'active' : ''}>Employers</button>}
      </div>
      <div className="tab-content">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default SignalTabs;
